var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"downloads-dedicated-panel"},[_c('app-select',{attrs:{"options":_vm.brands},on:{"valueChanged":_vm.handleBrandChanged}}),_c('app-select',{attrs:{"options":_vm.models,"disabled":!_vm.models.length},on:{"valueChanged":_vm.handleModelChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }